module.exports = __webpack_public_path__ + "img/app1.74fe7140.png";